import React, { ReactNode } from 'react';

import { CircularProgress, CircularProgressPropsColorOverrides, Palette } from '@mui/material';
import { Box, SxProps } from '@mui/system';

type PaletteItem = keyof Palette;

export type CenterCircularProgressProps = {
    color?: PaletteItem;
    sx?: SxProps;
    title?: ReactNode;
};

export const CenterCircularProgress: React.FunctionComponent<CenterCircularProgressProps> =
    function ({ color = 'primary', sx, title }: CenterCircularProgressProps) {
        return (
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    ...sx,
                }}
                data-testid="CenterCircularProgress"
            >
                <CircularProgress color={color as keyof CircularProgressPropsColorOverrides} />
                {title}
            </Box>
        );
    };
